const ServiceProcess = ({ service }) => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="container-custom">

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Our Process
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            How We Work
          </h2>

        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">

          {service.process.map((step, index) => (
            <div
              key={index}
              className="relative bg-white rounded-3xl p-8 text-center shadow-md"
            >

              <div className="w-16 h-16 rounded-full bg-[#F59E0B] text-white mx-auto flex items-center justify-center text-2xl font-bold">
                {index + 1}
              </div>

              <h3 className="text-lg font-bold text-[#082B57] mt-5">
                {step}
              </h3>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default ServiceProcess;